import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Link,
  useTheme,
  Stack,
  alpha,
  useMediaQuery,
} from "@mui/material";
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  WhatsApp,
  Terminal,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Logo from "../assets/Logo.png";
import image1 from "../assets/image1.jpeg";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isRtl = i18n.language === "ar";
const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const socialLinks = [
    { icon: <FacebookIcon fontSize="small" />, url: "https://www.facebook.com/share/1Jh718cNJx/?mibextid=wwXIfr" },
    { icon: <InstagramIcon fontSize="small" />, url: "https://www.instagram.com/red.90ninty?igsh=MXU5ZWNsMWwwMm43OA%3D%3D&utm_source=qr" },
    { icon: <WhatsApp fontSize="small" />, url: "https://wa.me/201041750711" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: `linear-gradient(rgba(10, 10, 10, 0.95), rgba(10, 10, 10, 0.95)), url(${image1}) center/cover fixed`, // لون أسود عميق مطفي مع صورة
        color: "#fff",
        py: { xs: 3, md: 4 }, // مسافات صغيرة
        borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
        direction: isRtl ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} alignItems="center">
          
          {/* اللوجو والوصف السريع */}
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: "center", md: "start" } }}>
            <img src={Logo} alt="Logo" style={{ height: "45px", marginBottom: "8px" }} />
            <Typography variant="caption" display="block" sx={{ opacity: 0.6 }}>
              {t("footer.description")}
            </Typography>
          </Grid>

          {/* معلومات التواصل - بشكل مختصر جداً */}
          <Grid item xs={12} md={4}>
            <Stack 
              direction={{ xs: "column", sm: "row", md: "column" }} 
              spacing={1} 
              alignItems={{ xs: "center", md: "flex-start" }}
              justifyContent="center"
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 16, color: theme.palette.primary.main }} />
                <Link href="tel:+201041750711" underline="none" color="inherit" variant="caption" sx={{ fontWeight: 700 }}>
                  01041750711
                </Link>
              </Box>
              <Link 
                href="https://maps.app.goo.gl/QKWS2WEMzGZ851nN8?g_st=ic" 
                target="_blank" 
                rel="noopener noreferrer" 
                underline="none" 
                color="inherit" 
                sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer", "&:hover": { color: theme.palette.primary.main } }}
              >
                <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.primary.main }} />
                <Typography variant="caption" sx={{ opacity: 0.8 }}>{t("footer.location")}</Typography>
              </Link>
            </Stack>
          </Grid>

          {/* السوشيال ميديا */}
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: "center", md: "end" } }}>
            <Stack direction="row" spacing={1} justifyContent={{ xs: "center", md: "flex-end" }}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  component="a"
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{ 
                    color: "#fff", 
                    bgcolor: alpha("#fff", 0.05),
                    "&:hover": { bgcolor: theme.palette.primary.main } 
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>

        {/* سطر بيانات المطور - واضح جداً */}
        <Box 
          sx={{ 
            mt: 3, 
            pt: 2, 
            borderTop: `1px solid ${alpha("#fff", 0.05)}`,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.4 }}>
            © {new Date().getFullYear()} Red PlayStation. {t("footer.copyright")}
          </Typography>

          <Link
            href="https://wa.me/201008974112"
            target="_blank"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              textDecoration: "none",
              color: "#fff",
              bgcolor: alpha(theme.palette.primary.main, 0.15),
              px: 1.5,
              py: 0.3,
              borderRadius: "4px",
              border: `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
              "&:hover": { bgcolor: theme.palette.primary.main }
            }}
          >
            <Terminal sx={{ fontSize: 14, color: theme.palette.primary.main }} />
            <Typography sx={{ fontSize: "10px", fontWeight: 900, letterSpacing: 0.5 }}>
              {t("footer.dev_by")} <span style={{ color: "#fff" }}>MOKHTAR MAHMOUD</span>
            </Typography>
          </Link>
        </Box>
      </Container>
      {isMobile && <Box sx={{ height: "80px" }} />}
    </Box>
  );
};

export default Footer;